<p-toast position="top-right" key="msj"></p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
    rejectButtonStyleClass="p-button-text" styleClass="dark-confirm"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
    rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar dark-confirm"
    [rejectVisible]="false"></p-confirmDialog>
<div class="d-flex justify-content-center">
    <div class="container-fluid" style="width: 90%;">
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card card-shadow sinborde">
                    <div class="card-header sinborde" style="background: none; ">
                        <div class="cardicono rounded">
                            <i class="pi pi-share-alt" style="color: #fff;"></i>
                        </div>
                        <header class="posicion" style="left: 6%; top: 0%;">Tipo de proyectos</header>
                    </div>
                    <div class="card-content">
                        <div class="row mt-3">
                            <p-table #dt1 [value]="tipoproyecto" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm p-datatable-striped" 
                                dataKey="id" [rows]="10" 
                                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [resizableColumns]="false"
                                [paginator]="true"  responsiveLayout="scroll" 
                                currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} registros"
                                [globalFilterFields]="['nombre','clv_activo']">
                                <ng-template pTemplate="caption">
                                    <div class="flex">
                                        <div class="col-md-3">
                                            <button pButton label="Limpiar" class="p-button-outlined"
                                            icon="pi pi-filter-slash" (click)="clear(dt1)" >
                                            </button>
                                        </div>
                                        <div class="col-md-3"></div>
                                        <div class="col-md-3 search-col"><span class="ml-auto search-field">
                                                <i class="pi pi-search mover"></i>
                                                <input pInputText #filtroInput id="filtro" type="text"
                                                    (input)="applyFilterGlobal($event, 'contains')"
                                                    placeholder="Buscar Palabra" />
                                            </span>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="min-width:15rem">
                                            <div class="flex align-items-center">
                                                Nombre del tipo de proyecto
                                                <p-columnFilter type="text" field="NombreMedioContacto"
                                                    display="menu"></p-columnFilter>
                                            </div>
                                        </th>
                                        <th style="min-width:10rem">
                                            <div class="flex align-items-center">
                                                Estatus
                                                <p-columnFilter type="text" field="des_mediosdecontacto"
                                                    display="menu"></p-columnFilter>
                                            </div>
                                        </th>
                                        <th></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-data let-index>
                                    <tr  [ngClass]="{'row-accessories': data.clv_activo ===0}">
                                        <td>
                                         <p class="ml-3">{{data.nombre}}</p>
                                        </td>
                                        <td>
                                            <p-tag *ngIf="data.clv_activo==1" icon="pi pi-user" [rounded]="true" severity='success' value="Activo"></p-tag>
                                            <p-tag *ngIf="data.clv_activo==0" icon="pi pi-user" [rounded]="true" severity='warning' value="Desactivado"></p-tag>
                                        </td>
                                        <td style="width: 130px;">
                                            <div class="d-flex justify-content-around table-actions">
                                                <button class="btn btn-info" pTooltip="Cambiar Estatus"
                                                    tooltipPosition="top">
                                                    <i class="pi pi-delete-left"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Sin tipos de proyecto.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div class="row mt-3 d-flex justify-content-center">
                                <div class="col-6">
                                    <div class="mt-3 mb-2">
                                        <p-colorPicker [(ngModel)]="color_gris_deshabilitadas"
                                            [disabled]="true"></p-colorPicker>
                                        <p class="text-left informativo" style="display: inline;">
                                            Tipos de proyecto Inactivos</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

